import clsx from "clsx";
import React from "react";

export type ToggleButtonOptions = {
  tooltipText?: string;
  content: React.ReactNode;
  value: string;
  disabled?: boolean;
};

export default function ToggleButtonGroup({
  buttonOptions,
  selectedValue,
  onChange,
  disabled,
}: {
  buttonOptions: ToggleButtonOptions[];
  selectedValue: string;
  onChange: (newValue: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="inline-flex h-[30px] max-h-[30px]">
      {buttonOptions.map((opt, idx) => {
        const isSelected = opt.value === selectedValue;
        const isDisabled = disabled || opt.disabled;

        return (
          <div
            key={opt.value}
            className={clsx(
              "p-[9px]",
              "flex items-center justify-center",
              !isSelected && "border border-solid border-neutral-300",
              idx === 0 && "rounded-tl-[6px] rounded-bl-[6px]",
              idx === buttonOptions.length - 1 && "rounded-tr-[6px] rounded-br-[6px]",
              isSelected ? "bg-primary-200 text-primary-700" : "bg-white text-neutral-600",
              isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
            )}
            onClick={() => {
              if (disabled || opt.disabled) return;

              if (opt.value !== selectedValue) {
                onChange(opt.value);
              }
            }}
          >
            {opt.content}
          </div>
        );
      })}
    </div>
  );
}
